module.exports = __webpack_public_path__ + "img/logo_large.20132602.png";